// Native-app feel on mobile: no page pinch-zoom, no rubber-band pan/overscroll,
// no double-tap zoom. Applied at runtime (onClientEntry) so it works in BOTH
// `gatsby develop` (which does NOT use src/html.tsx) and production.
//
// Why JS and not just the viewport meta: iOS Safari deliberately ignores the
// scale lock (user-scalable=no / maximum-scale), so the only reliable way to stop
// page pinch-zoom there is to preventDefault the non-standard gesture* events
// Safari fires for it. On Chrome/Android the meta lock is what matters and the
// gesture events never fire, so those listeners are harmless no-ops.
//
// Scoped to coarse-pointer (touch) devices so desktop trackpad pinch-zoom is NOT
// affected. Scrolling/panning inside scroll containers is untouched, and iOS's
// OS-level accessibility Zoom still works on the whole screen — so this is not the
// accessibility dead-end that blocking ALL zoom would be.

let installed = false

export function lockMobileZoom(): void {
    if (installed || typeof window === 'undefined' || typeof document === 'undefined') return
    if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) return // touch only
    installed = true

    // Lock the viewport scale (honored by Android/Chrome + standalone PWA; iOS
    // Safari ignores it — the gesture blocker below covers iOS). Set in JS so it
    // applies in `gatsby develop` too, not only the production html.tsx shell.
    const vp = document.querySelector('meta[name=viewport]')
    if (vp) vp.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no')

    // No rubber-band overscroll/pan; no double-tap zoom or 300ms tap delay.
    const root = document.documentElement
    root.style.overscrollBehavior = 'none'
    root.style.touchAction = 'manipulation'

    // iOS Safari page pinch-zoom: swallow the gesture* events.
    const block = (e: Event) => e.preventDefault()
    for (const ev of ['gesturestart', 'gesturechange', 'gestureend']) {
        document.addEventListener(ev, block, { passive: false })
    }
}
